import type { RouteRecordRaw } from 'vue-router';
import { PermissionAction, PermissionResource } from '@nailsupply/review-swagger/auth';
import { allDefaultstaffRoutes } from '@/pages/defaultstaff/routes';

export const defaultstaffRoutes: RouteRecordRaw = {
  path: '',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
    permission: { resource: PermissionResource.enum.default_employee, action: PermissionAction.enum.view },
  },
  children: [
    ...allDefaultstaffRoutes,
  ],
};
